import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { navshow } from '../../tool/navtool';
import Cookies from 'js-cookie';
import SearchModal from '../searchmodal/searchmodal';

class HeaderNav extends Component {
    constructor() {
        super()

    }

    componentDidMount() {
        window.onscroll = function () {
            var doc = document.documentElement;
            var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            var headerbox = document.querySelector(".headerbox")
            if (top >= 80) {
                headerbox && headerbox.setAttribute("class", "headerbox optionheader")
            }
            else {
                headerbox && headerbox.setAttribute("class", "headerbox")
            }
        }
    }




    render() {
        const headimg = Cookies.get("userinfo") ? JSON.parse(Cookies.get("userinfo")).headimg : "https://cdn.jsdelivr.net/gh/moezx/cdn@3.1.9/img/Sakura/images/none.png"
        return (
            <>

                <div className="headerbox" >

                    <a style={styles.aa} href="/" ><h1 className="NAME" style={styles.inline_block}><span></span></h1></a>
                    <div className="show-nav-box" style={styles.inline_block}>
                        <div id="show-nav" onClick={navshow}>
                            <div className="line line1"></div>
                            <div className="line line2"></div>
                            <div className="line line3"></div>
                        </div>

                        <div className="bigwinownav">
                            <div>
                                <Link style={styles.a} to="/" >
                                    <span className="faa-parent animated-hover">
                                        <i className="fa fa-fort-awesome faa-horizontal" aria-hidden="true"></i>
                                        首页
                        </span>
                                </Link>
                                <a style={styles.a} href="https://www.jianshu.com/u/e974af4433d8" target="_blanket">
                                    简书
                    </a>

                                <a style={styles.a} href="https://github.com/A-ANing" target="_blanket">
                                    Github
                    </a>


                                <Link style={styles.a} to="/FriendsLink">
                                    <span className="faa-parent animated-hover">
                                        <i className="fa fa-link faa-shake" aria-hidden="true"></i>
                                        友人帐
                                </span>
                                </Link>

                                <Link style={styles.a} to="/Board">
                                    <span className="faa-parent animated-hover">
                                        <i className="fa fa-pencil-square-o  faa-tada" aria-hidden="true"></i>
                                        留言板
                                </span>
                                </Link>

                                <Link style={styles.a} to="/About" className="About">
                                    <span className="faa-parent animated-hover"><i className="fa fa-leaf faa-wrench" aria-hidden="true"></i> 关于</span>
                                    {/* <ul className="sub-menu">
                                    <li><Link to="/about"><i className="fa fa-grav" aria-hidden="true"></i> 我？</Link></li>
                                </ul> */}
                                </Link>

                                <Link style={styles.a} to="/writeart">
                                    <span className="faa-parent animated-hover">
                                        <i className="iconfont icon-write" aria-hidden="true"></i>
                                        写文章
                                </span>

                                </Link>
                            </div>
                        </div>

                        <div className="header-user-avatar">
                            <Link to="/LoginPage">
                                <img className="faa-shake animated-hover" src={headimg} width="30" height="30" style={{ borderRadius: "30px" }} />
                            </Link>
                            {!Cookies.get("userinfo") && <div className="header-user-menu"><div className="herder-user-name no-logged">
                                Whether to
                                    <Link to="/LoginPage">
                                    log in
                                    </Link>
                                now?
                                    </div>
                            </div>}
                        </div>

                        <div className="searchbox"
                            onClick={() => {
                                console.log(this.SearchView)
                                this.SearchView.changeModal(true)
                            }}
                        ><i className="iconfont js-toggle-search iconsearch icon-search"></i></div>

                    </div>








                </div>

                <SearchModal onRef={e => this.SearchView = e} history={this.props.history}/>


            </>
        )
    }
}



const styles = {
    header: {

    },
    inline_block: {
        display: "inline-block"
    },
    name: {

    },
    aa: {
        height: "100%",
        cursor: "pointer",
        zIndex: 9,
        color: "inherit",
        textDecoration: "none",
        fontWeight: "500",
        lineHeight: "80px",
    },
    a: {
        cursor: "pointer",
        margin: "0 2.5rem",
        color: "inherit",
        textDecoration: "none",
        fontWeight: "500",
        lineHeight: "80px",
    }
}




export default connect()(HeaderNav)